export default {
  translations: {
    page: {
      helloworld: "Olá mundo com I18n",
    },
  },
};
